import { InternalSearchNoticeHit } from "components/page-components/Internal-Search/hit-components"
import React from "react"

export const NoticesHits = ({ hits, last_entry_ref, close_search_modal }) => {
  return (
    <div className="columns is-multiline">
      {hits?.map((hit, i) => (
        <div
          className="column is-half"
          key={hit.objectID}
          ref={
            i === Math.floor((hits.length / 20 - 1) * 20) - 1
              ? last_entry_ref
              : null
          }
        >
          <InternalSearchNoticeHit
            {...{ hit, is_internal_search: true, close_search_modal }}
          />
        </div>
      ))}
    </div>
  )
}
